import type { ReactElement } from "react";

import { useSelector } from "react-redux";

import {
    ColumnsSelectionModal,
    type SelectionModalProps,
} from "app/pages/sales-intelligence/common-components/column-picker";
import { selectActiveLeadsType, useColumnSelectionMutation } from "app/pages/sales-intelligence/modules/leads-search";
import { getLeadsSearchColumnListConfig } from "app/pages/sales-intelligence/modules/leads-search/configuration/columns/columnsConfig";
import { useLeadsColumnSelectionPlugins } from "app/pages/sales-intelligence/modules/leads-search/hooks/useLeadsColumnSelectionPlugins";

import { useLeadsColumnSelectionOptions } from "../../../hooks/useLeadsColumnSelectionOptions";

import { SELECTION_MODAL_TITLE } from "./const";

const SelectionModalContainer = ({ isOpen, closeModal }: SelectionModalProps): ReactElement => {
    const activeLeadsType = useSelector(selectActiveLeadsType);

    const { mutateAsync, isPending } = useColumnSelectionMutation();

    const { selectedColumnIds, categories, availableColumns } = useLeadsColumnSelectionOptions(
        getLeadsSearchColumnListConfig(),
        activeLeadsType,
    );

    const { config, pluginCleanup } = useLeadsColumnSelectionPlugins();

    const handleCloseModal = (): void => {
        closeModal();
        pluginCleanup();
    };

    const handleApply = async (columns: readonly string[]): Promise<void> => {
        await mutateAsync({ columns });

        handleCloseModal();
    };

    return (
        <ColumnsSelectionModal
            isOpened={isOpen}
            isApplyPending={isPending}
            title={SELECTION_MODAL_TITLE}
            initialSelectedColumnIds={selectedColumnIds}
            columnOptions={availableColumns}
            categoryConfig={categories}
            pluginConfig={config}
            onApply={handleApply}
            onCancel={handleCloseModal}
        />
    );
};

export default SelectionModalContainer;
